__turbopack_context__.v({
  "gallery_child": "Gallery-module-scss-module__TcZteW__gallery_child",
  "gallery_inner": "Gallery-module-scss-module__TcZteW__gallery_inner",
  "gallery_sec": "Gallery-module-scss-module__TcZteW__gallery_sec",
  "gallery_text": "Gallery-module-scss-module__TcZteW__gallery_text",
});
